<app-menu [moduloEnum]="moduloEnum" [funcionalidadeEnum]="funcionalidadeEnum"></app-menu>

<div class="container">
    <div class="row">
        <div class="col-12">
            <h1 class="title-default">Tabela IBPT</h1>
            <p class="descricao-tela">Carga tributária aproximada (Lei 12.741/2012) usada nas notas fiscais de todas as empresas. A tabela é única para o sistema e mantida pela ATS.</p>
        </div>
    </div>

    <!-- Aviso de falha: só falha da execução agendada, sem execução em andamento -->
    @if (situacao && situacao.avisoFalha && !isEmAndamento) {
        <div class="aviso aviso-erro">
            <span class="material-symbols-outlined">error</span>
            <div class="aviso-conteudo">
                <p class="aviso-titulo">{{ tituloAvisoFalha }}</p>
                <p>
                    @if (situacao.avisoFalha.listaDatetimeTentativa.length > 1) {
                        Tentamos {{ situacao.avisoFalha.listaDatetimeTentativa.length }} vezes, às {{ situacao.avisoFalha.listaDatetimeTentativa[0] | date:'HH:mm' }} e às {{ situacao.avisoFalha.listaDatetimeTentativa[situacao.avisoFalha.listaDatetimeTentativa.length - 1] | date:'HH:mm' }}, e todas falharam ({{ descricaoMotivoFalha(situacao.avisoFalha.ibptMotivoFalhaExecucao) }}).
                    } @else {
                        A verificação das {{ situacao.avisoFalha.listaDatetimeTentativa[0] | date:'HH:mm' }} falhou ({{ descricaoMotivoFalha(situacao.avisoFalha.ibptMotivoFalhaExecucao) }}) e não foram feitas novas tentativas.
                    }
                    A tabela continua na versão {{ situacao.versao ?? '—' }} e as emissões de nota não foram afetadas.
                    @if (situacao.avisoFalha.isErroAlerta) {
                        Não foi possível enviar o e-mail de alerta. Veja o log.
                    } @else if (situacao.avisoFalha.quantidadeDestinatariosAlerta === 0) {
                        Não há destinatários cadastrados para o alerta.
                    } @else {
                        Enviamos um e-mail para {{ situacao.avisoFalha.quantidadeDestinatariosAlerta }} destinatários às {{ situacao.avisoFalha.datetimeAlerta | date:'HH:mm' }}.
                    }
                </p>
                <div class="aviso-links">
                    <a class="btn-link" (click)="abrirDetalheExecucao(situacao.avisoFalha.idIbptExecucao)">Ver detalhes da execução</a>
                    <a class="btn-link" (click)="abrirImportacao()" *appTemPermissao="permissaoEnum.Desenvolvedor_TabelaIbpt_Incluir">Importar a planilha agora</a>
                    @if (situacao.avisoFalha.ibptMotivoFalhaExecucao === motivoFalhaEnum.CredenciaisRecusadas) {
                        <a class="btn-link" (click)="abrirAlterarCredencial()" *appTemPermissao="permissaoEnum.Desenvolvedor_TabelaIbpt_Excluir">Alterar CNPJ e token</a>
                    }
                </div>
            </div>
        </div>
    }

    <!-- Aviso de vigência vencida sem versão nova -->
    @if (situacao && situacao.ibptStatusTabela !== statusTabelaEnum.SemTabela && diasParaVencer !== null && diasParaVencer < 0) {
        <div class="aviso aviso-alerta">
            <span class="material-symbols-outlined">warning</span>
            <div class="aviso-conteudo">
                <p>A vigência da versão {{ situacao.versao }} terminou em {{ situacao.dataVigenciaFim | date:'dd/MM/yyyy' }} e o IBPT ainda não publicou uma nova versão. A tabela continua em uso.</p>
            </div>
        </div>
    }

    <div class="row cards-ibpt">
        <!-- Situação da tabela -->
        <div class="col-12 col-lg-7">
            <section class="card-ibpt">
                <div class="card-ibpt-header">
                    <h2 class="card-ibpt-titulo">Situação da tabela</h2>
                    @switch (situacao?.ibptStatusTabela) {
                        @case (statusTabelaEnum.Atualizada) {
                            <span class="chip-situacao chip-sucesso"><span class="material-symbols-outlined">check_circle</span>Atualizada</span>
                        }
                        @case (statusTabelaEnum.VerificacaoPendente) {
                            <span class="chip-situacao chip-alerta"><span class="material-symbols-outlined">warning</span>Verificação pendente</span>
                        }
                        @case (statusTabelaEnum.Atualizando) {
                            <span class="chip-situacao chip-info"><span class="material-symbols-outlined">autorenew</span>Atualizando</span>
                        }
                        @case (statusTabelaEnum.SemTabela) {
                            <span class="chip-situacao chip-erro"><span class="material-symbols-outlined">block</span>Sem tabela</span>
                        }
                    }
                </div>

                @if (!situacao) {
                    <app-loading-box [height]="'23'" [width]="'220'"></app-loading-box>
                    <app-loading-box [height]="'23'" [width]="'260'" [marginTop]="'20'"></app-loading-box>
                    <app-loading-box [height]="'23'" [width]="'180'" [marginTop]="'20'"></app-loading-box>
                } @else if (isEmAndamento && situacao.execucaoEmAndamento) {
                    <!-- Execução em andamento -->
                    <!-- Com o cancelamento pedido, o título vira "Cancelando…" até o worker encerrar a execução -->
                    @if (situacao.execucaoEmAndamento.ibptEtapaExecucao === etapaExecucaoEnum.AguardandoNovaTentativa) {
                        <div>
                            @if (situacao.execucaoEmAndamento.isCancelamentoSolicitado) {
                                <p class="progresso-titulo">Cancelando…</p>
                            } @else {
                                <p class="progresso-titulo">Aguardando nova tentativa às {{ situacao.execucaoEmAndamento.datetimeProximaTentativa | date:'HH:mm' }} (tentativa {{ situacao.execucaoEmAndamento.numeroTentativa }} de 3)</p>
                            }
                            <p class="texto-apoio">Tentativa {{ situacao.execucaoEmAndamento.numeroTentativa - 1 }}: {{ descricaoMotivoFalha(situacao.execucaoEmAndamento.ibptMotivoFalhaExecucaoTentativaAnterior) }}.</p>
                        </div>
                    } @else if (situacao.execucaoEmAndamento.ibptEtapaExecucao === null) {
                        <div>
                            <p class="progresso-titulo">{{ situacao.execucaoEmAndamento.isCancelamentoSolicitado ? 'Cancelando…' : descricaoEtapa(null) }}</p>
                            <p class="texto-apoio">A atualização começa em até 1 minuto.</p>
                        </div>
                    } @else {
                        <div>
                            <p class="progresso-titulo">{{ situacao.execucaoEmAndamento.isCancelamentoSolicitado ? 'Cancelando…' : descricaoEtapa(situacao.execucaoEmAndamento.ibptEtapaExecucao) }}</p>
                            <p class="texto-apoio">
                                {{ situacao.execucaoEmAndamento.quantidadeItensProcessados | number }} de {{ situacao.execucaoEmAndamento.quantidadeItensTotal | number }} itens
                                @if (situacao.execucaoEmAndamento.idUnidadeFederativaAtual) {
                                    · UF atual: {{ siglaUf(situacao.execucaoEmAndamento.idUnidadeFederativaAtual) }}
                                }
                            </p>
                        </div>
                        <mat-progress-bar mode="determinate" [value]="percentualProgresso"></mat-progress-bar>
                    }

                    <app-mapa-uf-ibpt class="mapa-andamento" tipo="andamento" [situacaoPorUf]="situacaoPorUfAndamento"></app-mapa-uf-ibpt>

                    <div class="campos-situacao campos-tres-colunas">
                        <div>
                            <p class="campo-label">Iniciada por</p>
                            <p class="campo-valor">{{ situacao.execucaoEmAndamento.nomeUsuarioAdmin ?? 'Sistema' }}</p>
                        </div>
                        <div>
                            <p class="campo-label">Início</p>
                            <p class="campo-valor">{{ situacao.execucaoEmAndamento.datetimeInicio | date:"dd/MM/yyyy 'às' HH:mm" }}</p>
                        </div>
                        <div>
                            <p class="campo-label">Versão em uso até concluir</p>
                            <p class="campo-valor">{{ situacao.execucaoEmAndamento.versaoAnterior ?? '—' }}</p>
                        </div>
                    </div>

                    <div class="acoes-card">
                        <button type="button" mat-button class="btn-primary" disabled matTooltip="Já existe uma execução em andamento.">
                            <span class="material-symbols-outlined">sync</span> Atualizar agora
                        </button>
                        <button type="button" mat-button class="btn-secundary" disabled matTooltip="Já existe uma execução em andamento.">
                            <span class="material-symbols-outlined">upload_file</span> Importar planilha
                        </button>
                        <button type="button" mat-button class="btn-secundary" (click)="confirmarCancelamentoExecucao()" [disabled]="situacao.execucaoEmAndamento.isCancelamentoSolicitado || isSolicitandoCancelamento" *appTemPermissao="permissaoEnum.Desenvolvedor_TabelaIbpt_Alterar">
                            @if (isSolicitandoCancelamento) {
                                <mat-spinner [diameter]="20" class="mat-spinner-btn"></mat-spinner>
                            } @else {
                                <span class="material-symbols-outlined">cancel</span> Cancelar atualização
                            }
                        </button>
                    </div>
                    <p class="texto-apoio">Você pode sair desta tela. A atualização continua e o resultado aparece no histórico.</p>
                } @else {
                    <div class="versao-situacao">
                        <span class="versao-numero">{{ situacao.versao ?? '—' }}</span>
                        @if (situacao.ibptStatusTabela === statusTabelaEnum.Atualizada) {
                            <span class="texto-apoio">versão vigente</span>
                        } @else if (situacao.ibptStatusTabela === statusTabelaEnum.VerificacaoPendente) {
                            <span class="texto-apoio">versão em uso</span>
                        }
                    </div>

                    <div class="campos-situacao">
                        <div>
                            <p class="campo-label">Vigência</p>
                            @if (situacao.dataVigenciaInicio && situacao.dataVigenciaFim) {
                                <p class="campo-valor">{{ situacao.dataVigenciaInicio | date:'dd/MM/yyyy' }} a {{ situacao.dataVigenciaFim | date:'dd/MM/yyyy' }}</p>
                            } @else {
                                <p class="campo-valor">—</p>
                            }
                            <p class="campo-apoio" [class.texto-alerta]="diasParaVencer !== null && diasParaVencer >= 0 && diasParaVencer <= 7" [class.texto-erro]="diasParaVencer !== null && diasParaVencer < 0">{{ textoVencimento }}</p>
                        </div>
                        <div>
                            <p class="campo-label">Última atualização</p>
                            @if (situacao.datetimeUltimaAtualizacao) {
                                <p class="campo-valor">{{ situacao.datetimeUltimaAtualizacao | date:"dd/MM/yyyy 'às' HH:mm" }}</p>
                                <p class="campo-apoio">via {{ descricaoOrigem(situacao.ibptOrigemExecucaoUltimaAtualizacao) }} · {{ situacao.nomeResponsavelUltimaAtualizacao ?? 'Sistema' }}</p>
                            } @else {
                                <p class="campo-valor">—</p>
                                <p class="campo-apoio">nenhuma carga feita</p>
                            }
                        </div>
                        @if (situacao.ibptStatusTabela === statusTabelaEnum.VerificacaoPendente) {
                            <div>
                                <p class="campo-label">Última verificação com sucesso</p>
                                <p class="campo-valor">{{ (situacao.datetimeUltimaVerificacaoSucesso | date:"dd/MM/yyyy 'às' HH:mm") ?? '—' }}</p>
                                <p class="campo-apoio">{{ situacao.quantidadeFalhasConsecutivas }} {{ situacao.quantidadeFalhasConsecutivas === 1 ? 'verificação com falha' : 'verificações com falha' }} desde então</p>
                            </div>
                        } @else {
                            <div>
                                <p class="campo-label">Última verificação</p>
                                <p class="campo-valor">{{ (situacao.datetimeUltimaVerificacao | date:"dd/MM/yyyy 'às' HH:mm") ?? '—' }}</p>
                                @if (situacao.ibptResultadoExecucaoUltimaVerificacao === resultadoExecucaoEnum.SemAlteracao) {
                                    <p class="campo-apoio">sem alteração de versão</p>
                                } @else if (situacao.ibptResultadoExecucaoUltimaVerificacao === resultadoExecucaoEnum.Sucesso) {
                                    <p class="campo-apoio">nova versão carregada</p>
                                }
                            </div>
                        }
                        <div>
                            <p class="campo-label">Próxima verificação</p>
                            <p class="campo-valor">{{ (situacao.datetimeProximaVerificacao | date:"dd/MM/yyyy 'às' HH:mm") ?? '—' }}</p>
                            <p class="campo-apoio">todos os dias</p>
                        </div>
                    </div>

                    <div class="campos-situacao campos-tres-colunas contadores">
                        <div>
                            <p class="contador-valor">{{ situacao.quantidadeProdutos | number }}</p>
                            <p class="campo-label">Produtos (NCM)</p>
                        </div>
                        <div>
                            <p class="contador-valor">{{ situacao.quantidadeServicos | number }}</p>
                            <p class="campo-label">Serviços (NBS e LC 116)</p>
                        </div>
                        <div>
                            <p class="contador-valor">{{ situacao.quantidadeUfs }}</p>
                            <p class="campo-label">UFs atendidas</p>
                        </div>
                    </div>

                    <app-mapa-uf-ibpt class="mapa-andamento" tipo="situacao" [situacaoPorUf]="situacaoPorUfCarregada"></app-mapa-uf-ibpt>

                    @if (situacao.ibptStatusTabela === statusTabelaEnum.SemTabela) {
                        <div class="aviso aviso-erro aviso-compacto">
                            <p>A tabela ainda não foi carregada. Até a primeira carga, as notas não terão a carga tributária aproximada.</p>
                        </div>
                    }

                    @if (situacao.ibptStatusTabela === statusTabelaEnum.VerificacaoPendente) {
                        <div class="acoes-card">
                            <button type="button" mat-button class="btn-primary" (click)="abrirImportacao()" *appTemPermissao="permissaoEnum.Desenvolvedor_TabelaIbpt_Incluir">
                                <span class="material-symbols-outlined">upload_file</span> Importar planilha
                            </button>
                            <button type="button" mat-button class="btn-secundary" [disabled]="isSolicitandoAtualizacao" (click)="solicitarAtualizacao()" *appTemPermissao="permissaoEnum.Desenvolvedor_TabelaIbpt_Alterar">
                                @if (isSolicitandoAtualizacao) {
                                    <mat-spinner [diameter]="20" class="mat-spinner-btn"></mat-spinner>
                                } @else {
                                    <span class="material-symbols-outlined">sync</span> Tentar novamente
                                }
                            </button>
                        </div>
                        @if (situacao.ibptMotivoFalhaExecucaoPendente === motivoFalhaEnum.CredenciaisRecusadas) {
                            <p class="texto-apoio">O IBPT recusou o CNPJ e o token. Altere-os no card API do IBPT e tente novamente.</p>
                        } @else {
                            <p class="texto-apoio">Se a API continuar fora do ar, baixe a planilha no site De Olho no Imposto e importe aqui. A carga manual fica registrada com seu nome.</p>
                        }
                    } @else {
                        <div class="acoes-card">
                            <button type="button" mat-button class="btn-primary" [disabled]="isSolicitandoAtualizacao" (click)="solicitarAtualizacao()" *appTemPermissao="permissaoEnum.Desenvolvedor_TabelaIbpt_Alterar">
                                @if (isSolicitandoAtualizacao) {
                                    <mat-spinner [diameter]="20" class="mat-spinner-btn"></mat-spinner>
                                } @else {
                                    <span class="material-symbols-outlined">sync</span> Atualizar agora
                                }
                            </button>
                            <button type="button" mat-button class="btn-secundary" (click)="abrirImportacao()" *appTemPermissao="permissaoEnum.Desenvolvedor_TabelaIbpt_Incluir">
                                <span class="material-symbols-outlined">upload_file</span> Importar planilha
                            </button>
                        </div>
                        @if (situacao.ibptStatusTabela === statusTabelaEnum.Atualizada) {
                            <p class="texto-apoio">A atualização automática roda todos os dias às 03:00. Se a API do IBPT estiver fora do ar, use Importar planilha.</p>
                        }
                    }
                }
            </section>
        </div>

        <!-- API do IBPT -->
        <div class="col-12 col-lg-5">
            <section class="card-ibpt">
                <div class="card-ibpt-header">
                    <h2 class="card-ibpt-titulo">API do IBPT</h2>
                    @if (isTestandoConexao) {
                        <span class="chip-situacao chip-info"><span class="material-symbols-outlined">hourglass_top</span>Testando</span>
                    } @else {
                        @switch (configuracao?.ibptStatusConexao) {
                            @case (statusConexaoEnum.Conectada) {
                                <span class="chip-situacao chip-sucesso"><span class="material-symbols-outlined">link</span>Conectada</span>
                            }
                            @case (statusConexaoEnum.SemResposta) {
                                <span class="chip-situacao chip-erro"><span class="material-symbols-outlined">link_off</span>Sem resposta</span>
                            }
                            @case (statusConexaoEnum.CredenciaisRecusadas) {
                                <span class="chip-situacao chip-erro"><span class="material-symbols-outlined">link_off</span>Credenciais recusadas</span>
                            }
                        }
                    }
                </div>

                @if (configuracao) {
                    <div>
                        <p class="campo-label">CNPJ de consulta</p>
                        <p class="campo-valor">{{ cnpjFormatado || '—' }}</p>
                    </div>
                    <div>
                        <p class="campo-label">Token de integração</p>
                        @if (configuracao.finalToken) {
                            <p class="campo-valor token-mascarado">••••••••••••{{ configuracao.finalToken }}</p>
                        } @else {
                            <p class="campo-valor">—</p>
                        }
                        @if (configuracao.datetimeUltimoTeste) {
                            @if (configuracao.ibptStatusConexao === statusConexaoEnum.Conectada) {
                                <p class="campo-apoio">Testado com sucesso em {{ configuracao.datetimeUltimoTeste | date:"dd/MM/yyyy 'às' HH:mm" }}</p>
                            } @else {
                                <p class="campo-apoio texto-erro">Falha no teste em {{ configuracao.datetimeUltimoTeste | date:"dd/MM/yyyy 'às' HH:mm" }}</p>
                            }
                        }
                        @if (configuracao.nomeUsuarioAdminAlteracaoCredencial && configuracao.datetimeAlteracaoCredencial) {
                            <p class="campo-apoio">Alterado por {{ configuracao.nomeUsuarioAdminAlteracaoCredencial }} em {{ configuracao.datetimeAlteracaoCredencial | date:"dd/MM/yyyy 'às' HH:mm" }}</p>
                        }
                    </div>

                    <div class="acoes-card">
                        <button type="button" mat-button class="btn-secundary" (click)="abrirAlterarCredencial()" *appTemPermissao="permissaoEnum.Desenvolvedor_TabelaIbpt_Excluir">
                            <span class="material-symbols-outlined">edit</span> Alterar CNPJ e token
                        </button>
                        <button type="button" mat-button class="btn-secundary" [disabled]="isTestandoConexao" (click)="testarConexao()" *appTemPermissao="permissaoEnum.Desenvolvedor_TabelaIbpt_Alterar">
                            @if (isTestandoConexao) {
                                <mat-spinner [diameter]="20" class="mat-spinner-btn"></mat-spinner>
                            } @else {
                                <span class="material-symbols-outlined">bolt</span> Testar conexão
                            }
                        </button>
                    </div>

                    <div class="destinatarios">
                        <div class="destinatarios-header">
                            <p class="campo-label">Alertas por e-mail</p>
                            <a class="btn-link" (click)="abrirDestinatario()" *appTemPermissao="permissaoEnum.Desenvolvedor_TabelaIbpt_Excluir">Gerenciar destinatários</a>
                        </div>
                        <div class="lista-destinatario">
                            @for (email of configuracao.listaEmailDestinatario; track email) {
                                <span class="chip-destinatario">{{ email }}</span>
                            }
                        </div>
                        @if (situacao?.avisoFalha?.datetimeAlerta) {
                            <p class="campo-apoio">Último alerta enviado em {{ situacao?.avisoFalha?.datetimeAlerta | date:"dd/MM/yyyy 'às' HH:mm" }}.</p>
                        } @else {
                            <p class="campo-apoio">Enviados quando a atualização automática falhar.</p>
                        }
                        @if (configuracao.nomeUsuarioAdminAlteracaoDestinatario && configuracao.datetimeAlteracaoDestinatario) {
                            <p class="campo-apoio">Alterado por {{ configuracao.nomeUsuarioAdminAlteracaoDestinatario }} em {{ configuracao.datetimeAlteracaoDestinatario | date:"dd/MM/yyyy 'às' HH:mm" }}</p>
                        }
                    </div>
                } @else {
                    <app-loading-box [height]="'23'" [width]="'220'"></app-loading-box>
                    <app-loading-box [height]="'23'" [width]="'260'" [marginTop]="'20'"></app-loading-box>
                    <app-loading-box [height]="'23'" [width]="'180'" [marginTop]="'20'"></app-loading-box>
                }
            </section>
        </div>
    </div>

    <!-- Histórico de execuções -->
    <section class="historico" id="historico">
        <div class="historico-header">
            <h2 class="subtitle-default">Histórico de execuções</h2>
        </div>

        <form class="search-area" (ngSubmit)="pesquisar()">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-3">
                    <mat-form-field appearance="outline">
                        <mat-label>Período</mat-label>
                        <mat-select [(ngModel)]="filtroPeriodo" name="filtroPeriodo">
                            @for (periodo of listaPeriodo; track periodo.descricao) {
                                <mat-option [value]="periodo.quantidadeDias">{{ periodo.descricao }}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <mat-form-field appearance="outline">
                        <mat-label>Origem</mat-label>
                        <mat-select [(ngModel)]="filtroOrigem" name="filtroOrigem">
                            <mat-option [value]="null">Todas</mat-option>
                            <mat-option [value]="origemExecucaoEnum.Api">API</mat-option>
                            <mat-option [value]="origemExecucaoEnum.Planilha">Planilha</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <mat-form-field appearance="outline">
                        <mat-label>Resultado</mat-label>
                        <mat-select [(ngModel)]="filtroResultado" name="filtroResultado">
                            <mat-option [value]="null">Todos</mat-option>
                            <mat-option [value]="resultadoExecucaoEnum.Sucesso">Sucesso</mat-option>
                            <mat-option [value]="resultadoExecucaoEnum.SemAlteracao">Sem alteração</mat-option>
                            <mat-option [value]="resultadoExecucaoEnum.Falha">Falha</mat-option>
                            <mat-option [value]="resultadoExecucaoEnum.Cancelada">Cancelada</mat-option>
                            <mat-option [value]="resultadoExecucaoEnum.EmAndamento">Em andamento</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <button type="submit" mat-button class="btn-secundary">Pesquisar</button>
                </div>
            </div>
        </form>

        @if (isCarregandoHistorico && listaExecucaoExibida.length === 0) {
            <app-loading-box [height]="'23'" [width]="'220'"></app-loading-box>
            <app-loading-box [height]="'23'" [width]="'260'" [marginTop]="'20'"></app-loading-box>
            <app-loading-box [height]="'23'" [width]="'180'" [marginTop]="'20'"></app-loading-box>
        } @else if (listaExecucaoExibida.length > 0) {
            <div class="tabela-historico">
            <table mat-table [dataSource]="listaExecucaoExibida">
                <ng-container matColumnDef="datetimeInicio">
                    <th mat-header-cell *matHeaderCellDef> Data e hora </th>
                    <td mat-cell *matCellDef="let execucao"> {{ execucao.datetimeInicio | date:'dd/MM/yyyy HH:mm' }} </td>
                </ng-container>

                <ng-container matColumnDef="origem">
                    <th mat-header-cell *matHeaderCellDef> Origem </th>
                    <td mat-cell *matCellDef="let execucao"> {{ descricaoOrigem(execucao.ibptOrigemExecucao) }} </td>
                </ng-container>

                <ng-container matColumnDef="responsavel">
                    <th mat-header-cell *matHeaderCellDef class="col-responsiva"> Responsável </th>
                    <td mat-cell *matCellDef="let execucao" class="col-responsiva"> {{ execucao.nomeUsuarioAdmin ?? 'Sistema' }} </td>
                </ng-container>

                <ng-container matColumnDef="versao">
                    <th mat-header-cell *matHeaderCellDef> Versão </th>
                    <td mat-cell *matCellDef="let execucao"> {{ execucao.versao ?? '—' }} </td>
                </ng-container>

                <ng-container matColumnDef="resultado">
                    <th mat-header-cell *matHeaderCellDef> Resultado </th>
                    <td mat-cell *matCellDef="let execucao">
                        <span class="chip-resultado"
                            [class.chip-resultado-sucesso]="execucao.ibptResultadoExecucao === resultadoExecucaoEnum.Sucesso"
                            [class.chip-resultado-sem-alteracao]="execucao.ibptResultadoExecucao === resultadoExecucaoEnum.SemAlteracao"
                            [class.chip-resultado-falha]="execucao.ibptResultadoExecucao === resultadoExecucaoEnum.Falha"
                            [class.chip-resultado-em-andamento]="execucao.ibptResultadoExecucao === resultadoExecucaoEnum.EmAndamento"
                            [class.chip-resultado-cancelada]="execucao.ibptResultadoExecucao === resultadoExecucaoEnum.Cancelada">
                            <span class="material-symbols-outlined">{{ iconeResultado(execucao.ibptResultadoExecucao) }}</span>
                            {{ descricaoResultado(execucao.ibptResultadoExecucao) }}
                        </span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="detalhe">
                    <th mat-header-cell *matHeaderCellDef class="coluna-detalhe"> Detalhe </th>
                    <td mat-cell *matCellDef="let execucao" class="coluna-detalhe"> {{ montarDetalhe(execucao) }} </td>
                </ng-container>

                <ng-container matColumnDef="duracao">
                    <th mat-header-cell *matHeaderCellDef> Duração </th>
                    <td mat-cell *matCellDef="let execucao" class="sem-quebra"> {{ formatarDuracao(execucao) }} </td>
                </ng-container>

                <ng-container matColumnDef="acao">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let execucao">
                        <button type="button" mat-mini-fab class="fab-action default" matTooltip="Ver detalhe da execução" aria-label="Ver detalhe da execução" [disabled]="idIbptExecucaoCarregandoDetalhe !== null" (click)="abrirDetalheExecucao(execucao.idIbptExecucao)">
                            @if (idIbptExecucaoCarregandoDetalhe === execucao.idIbptExecucao) {
                                <mat-spinner [diameter]="20" class="mat-spinner-btn"></mat-spinner>
                            } @else {
                                <mat-icon>visibility</mat-icon>
                            }
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            </div>

            @if (!isUltimaPagina) {
                <div class="col-12 text-center ver-mais-pesquisa">
                    <button type="button" mat-button class="btn-primary" [disabled]="isCarregandoHistorico" (click)="verMais()">
                        @if (isCarregandoHistorico) {
                            <mat-spinner [diameter]="20" class="mat-spinner-btn"></mat-spinner>
                        } @else {
                            <span class="material-symbols-outlined">keyboard_arrow_down</span>
                            Ver mais
                        }
                    </button>
                </div>
            }
        } @else {
            <app-empty-list [title]="'Nenhuma execução encontrada com o filtro informado.'"></app-empty-list>
        }
    </section>
</div>
